import { VendorEvaluationModel } from "@/services/vendorEvaluationService";
import * as vendorEvaluationController from "@/services/vendorEvaluationService";
import { getUserLogin } from "@/utils/auth";
import Swal from "sweetalert2";

export default {
  name: "VendorEvaluationForm",
  data() {
    return {
      categories: [],
      options: { jenisSupplier: [], jenisProdukJasa: [], kesimpulan: [] },
      model: new VendorEvaluationModel(),
      loading: false,
      saving: false,
      isComplete: false,
      rataRata: null,
      kesimpulanLabel: null,
      threshold: vendorEvaluationController.THRESHOLD,
      nilaiScale: vendorEvaluationController.NILAI_SCALE,
      isView: false,
      evalType: "SUPPLIER",
      approving: false,
      rejecting: false,
      rejectReasonInput: "",
      showRejectBox: false,
    };
  },
  computed: {
    currentUser() {
      return getUserLogin();
    },
    hasAdminCategory() {
      return this.categories.some((c) => c.categoryId === 6);
    },
    hasNdaCategory() {
      return this.categories.some((c) => c.categoryId === 7);
    },
    rataRataDisplay() {
      return this.rataRata !== null ? this.rataRata.toFixed(2) : "-";
    },
    jenisSupplierLabel() {
      const v = this.model.jenis_supplier;
      if (v === null || v === undefined || v === "") return "-";
      const opt = (this.options.jenisSupplier || []).find(
        (o) => Number(o.value) === Number(v),
      );
      if (!opt) return "-";
      if (
        opt.description === "Lain-lain" &&
        this.model.jenis_supplier_lainnya
      ) {
        return `${opt.description}: ${this.model.jenis_supplier_lainnya}`;
      }
      return opt.description;
    },
    jenisProdukJasaLabel() {
      const v = this.model.jenis_produk_jasa;
      if (v === null || v === undefined || v === "") return "-";
      const opt = (this.options.jenisProdukJasa || []).find(
        (o) => Number(o.value) === Number(v),
      );
      return opt?.description || "-";
    },
    isJenisSupplierLainnya() {
      const opt = (this.options.jenisSupplier || []).find(
        (o) => o.value === this.model.jenis_supplier,
      );
      return opt?.description === "Lain-lain";
    },
    isFormValid() {
      const isTransport =
        (this.evalType || this.model.eval_type) === "TRANSPORT";
      if (!isTransport) {
        if (!this.model.jenis_supplier) return false;
        if (
          this.isJenisSupplierLainnya &&
          !this.model.jenis_supplier_lainnya?.trim()
        ) {
          return false;
        }
        if (!this.model.jenis_produk_jasa) return false;
      }
      if (!this.model.evaluation_date) return false;
      if (!this.isComplete) return false;
      return true;
    },
    canApprove() {
      return (
        this.isView &&
        this.model.approval_status === "PENDING" &&
        this.currentUser?.mst_employee_id &&
        this.model.approver_employee_id === this.currentUser.mst_employee_id
      );
    },
    companyInfo() {
      const COMPANY_MAP = {
        2: {
          name: "PT. Fastana Logistik Indonesia",
          logo: "/assets/img/logo_fli.png",
        },
        2062: {
          name: "PT. Fastana Warehouse Indonesia",
          logo: "/assets/img/fwi.png",
        },
      };
      return COMPANY_MAP[Number(this.model.company)] || COMPANY_MAP[2]; // default FLI
    },
  },
  watch: {
    "model.nilai": {
      deep: true,
      handler() {
        const { isComplete, rataRata, kesimpulanId, kesimpulanLabel } =
          vendorEvaluationController.evaluateForm(
            this.model,
            this.options.kesimpulan,
          );
        this.isComplete = isComplete;
        this.rataRata = rataRata;
        this.kesimpulanLabel = kesimpulanLabel;
        this.model.rata_rata_nilai = rataRata;
        this.model.kesimpulan = kesimpulanId;
      },
    },
    "$route.query"() {
      this.loadPage();
    },
  },
  async created() {
    this.loadPage();
  },
  methods: {
    /** Kembali ke halaman asal (Approval Evaluasi atau Monitoring Document) */
    goBack() {
      const from = this.$route.query.from;
      if (from === "approval") {
        this.$router.push("/evaluation/evaluation-approval");
      } else if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/monitoring-document");
      }
    },

    async loadPage() {
      this.loading = true;
      try {
        // ID bisa dari params (/vendor-evaluation/:id) atau query (?evaluationId=)
        const evaluationId =
          this.$route.params.id ||
          this.$route.query.evaluationId ||
          this.$route.query.id ||
          null;

        if (evaluationId) {
          const data = await vendorEvaluationController.getById(evaluationId);
          this.categories = data.categories;
          this.options = data.options;
          this.model = new VendorEvaluationModel(data.model);
          if (data.model?.company != null && data.model?.company !== "") {
            this.model.company = Number(data.model.company);
          } else if (this.$route.query.company) {
            this.model.company = Number(this.$route.query.company);
          }
          // Pastikan tipe number biar radio/select cocok dengan option.value
          if (
            this.model.jenis_supplier !== null &&
            this.model.jenis_supplier !== undefined &&
            this.model.jenis_supplier !== ""
          ) {
            this.model.jenis_supplier = Number(this.model.jenis_supplier);
          }
          if (
            this.model.jenis_produk_jasa !== null &&
            this.model.jenis_produk_jasa !== undefined &&
            this.model.jenis_produk_jasa !== ""
          ) {
            this.model.jenis_produk_jasa = Number(this.model.jenis_produk_jasa);
          }
          // 0 = placeholder TRANSPORT / data kosong → anggap null di tampilan
          if (this.model.jenis_supplier === 0) this.model.jenis_supplier = null;
          if (this.model.jenis_produk_jasa === 0)
            this.model.jenis_produk_jasa = null;
          this.isView = true;
          this.evalType = data.model?.eval_type || data.eval_type || "SUPPLIER";
        } else {
          const { categories, options, model, evalType } =
            await vendorEvaluationController.initForm(this.$route.query);
          this.categories = categories;
          this.options = options;
          this.model = model;
          this.evalType = evalType || model.eval_type || "SUPPLIER";
          this.isView = false;
          if (this.$route.query.company) {
            this.model.company = Number(this.$route.query.company);
          }

          if (this.currentUser) {
            this.model.penilai_id = this.currentUser.mst_employee_id;
            this.model.penilai_name = this.currentUser.mst_employee_name;
          }
        }
      } catch (err) {
        console.error(err);
        await Swal.fire({
          icon: "error",
          title: "Gagal",
          text: err.message || "Gagal memuat data evaluasi",
        });
        this.goBack();
      } finally {
        this.loading = false;
      }
    },

    letterFor(index) {
      return String.fromCharCode(97 + index);
    },
    getCategoryLabel(cat) {
      switch (cat.categoryId) {
        case 6:
          return `${cat.categoryLabel} **`;
        case 7:
          return `${cat.categoryLabel} ***`;
        default:
          return `${cat.categoryLabel} `;
      }
    },
    formatDate(date) {
      if (!date) return "-";
      return new Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(new Date(date));
    },

    async handleSave() {
      if (!this.isFormValid) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Lengkapi semua field wajib sebelum menyimpan.",
        });
        return;
      }

      this.saving = true;
      try {
        const created = await vendorEvaluationController.submitForm(this.model);
        await vendorEvaluationController.submitForEvaluationApproval(
          created.data.evaluation_id,
        );

        await Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Evaluasi berhasil disimpan dan dikirim untuk approval",
        });
        this.$router.push("/monitoring-document");
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: err.response?.data?.message || "Gagal menyimpan evaluasi",
        });
      } finally {
        this.saving = false;
      }
    },

    async handleApprove() {
      const confirm = await Swal.fire({
        icon: "question",
        title: "Setujui evaluasi ini?",
        showCancelButton: true,
        confirmButtonText: "Ya, setujui",
        cancelButtonText: "Batal",
      });
      if (!confirm.isConfirmed) return;

      this.approving = true;
      try {
        await vendorEvaluationController.approveEvaluation(
          this.model.evaluation_id,
          this.rejectReasonInput || null,
        );
        await Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Evaluasi disetujui",
        });
        this.goBack();
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: err.response?.data?.message || "Gagal menyetujui evaluasi",
        });
      } finally {
        this.approving = false;
      }
    },

    async handleReject() {
      if (!this.rejectReasonInput?.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Alasan penolakan wajib diisi",
        });
        return;
      }

      const confirm = await Swal.fire({
        icon: "warning",
        title: "Tolak evaluasi ini?",
        text: "Evaluasi akan dianulir dan pembuat harus membuat evaluasi baru.",
        showCancelButton: true,
        confirmButtonText: "Ya, tolak",
        cancelButtonText: "Batal",
      });
      if (!confirm.isConfirmed) return;

      this.rejecting = true;
      try {
        await vendorEvaluationController.rejectEvaluation(
          this.model.evaluation_id,
          this.rejectReasonInput,
        );
        await Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Evaluasi ditolak",
        });
        this.goBack();
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: err.response?.data?.message || "Gagal menolak evaluasi",
        });
      } finally {
        this.rejecting = false;
      }
    },

    async goToCreateNew() {
      const confirm = await Swal.fire({
        icon: "question",
        title: "Buat evaluasi baru?",
        text: "Anda akan membuat evaluasi baru untuk vendor ini. Data evaluasi yang ditolak tetap tersimpan sebagai riwayat, tapi Anda perlu mengisi ulang semua penilaian dari awal.",
        showCancelButton: true,
        confirmButtonText: "Ya, buat baru",
        cancelButtonText: "Batal",
      });
      if (!confirm.isConfirmed) return;

      try {
        const auth =
          await vendorEvaluationController.checkCreateAuthorization();

        if (!auth.data?.authorized) {
          Swal.fire({
            icon: "warning",
            title: "Tidak Berwenang",
            text: "Anda tidak berwenang membuat evaluasi vendor untuk site/posisi Anda. Hubungi admin jika ini seharusnya diizinkan.",
          });
          return;
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal memeriksa otorisasi Anda. Coba lagi.",
        });
        return;
      }

      this.$router.push({
        path: "/vendor-evaluation",
        query: {
          documentId: this.model.document_id,
          vendorId: this.model.mst_corporate_id,
          namaSupplier: this.model.nama_supplier,
        },
      });
    },
  },
};
